import {
  InvoicesOfMilestoneList,
  InvoicesList,
  InvoiceSummary,
  latestInvoiceVersion,
  invoiceTracker,
} from '../../../../../../types/ProjectManagement/Project/ProjectView/Invoices/invoicesTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../../../utils/apiUtils'
import {
  projectInvoicesApiConfig,
  AllowedHttpMethods,
} from '../../../../apiList'

const getClosedMilestonesAndCRs = async (
  projectId: number | string,
): Promise<InvoicesList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.getClosedMilestonesAndCRs,
    method: AllowedHttpMethods.get,
    params: {
      projectId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getInvoicesOfMilestone = async (
  milestoneId: number,
): Promise<InvoicesOfMilestoneList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.getInvoicesOfMilestone,
    method: AllowedHttpMethods.get,
    params: {
      milestoneId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getInvoiceSummary = async (
  invoiceId: number,
): Promise<InvoiceSummary> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.getInvoiceSummary,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getlatestInvoiceSummary = async (
  invoiceId: number,
): Promise<latestInvoiceVersion> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.latestInvoiceVersion,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const isProformaRefrece = async (invoiceId: number): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.isProformaRefrece,
    method: AllowedHttpMethods.get,
    params: {
      invoiceId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getInvoicePDF = async (data: string): Promise<string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: projectInvoicesApiConfig.getInvoicePDF,
    method: AllowedHttpMethods.post,
    data,
  })
  const response = await useAxios(requestConfig)
  return response.data
}
const getInvoiceTracker = async (
  invoiceTrackerProps: invoiceTracker,
): Promise<invoiceTracker> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url:
      projectInvoicesApiConfig.invoiceTracker +
      `/?invoiceId=${invoiceTrackerProps.invoiceId}`,
    method: AllowedHttpMethods.post,

    data: invoiceTrackerProps,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const invoicesApi = {
  getClosedMilestonesAndCRs,
  getInvoicesOfMilestone,
  getInvoiceSummary,
  isProformaRefrece,
  getInvoicePDF,
  getlatestInvoiceSummary,
  getInvoiceTracker,
}

export default invoicesApi
